import React, { Component } from "react";
import DownArrow from "../images/DownArrow.svg";

import Coffin from "../images/Coffin.svg";
import { Fade } from "react-awesome-reveal";

export default class Footer extends Component {
  render() {
    const { label, children, ...props } = this.props;
    return (
      <section {...props} className="lg:pt-24">
        <Fade triggerOnce>
          <div className="flex flex-col my-8 items-center justify-center text-center">
            <div className="my-4">
              <img src={DownArrow} alt="Down" />
            </div>
            <p className="my-8 h6 text-hugeorange">{label}</p>
            <div className="mt-4 mb-10 px-4">
              {children}
            </div>
          </div>
        </Fade>
        <div className="coffin-container pt-8 pb-12 md:pt-10 md:pb-16 lg:pt-16 lg:pb-24">
          <img src={Coffin} alt="Coffin" className="ml-auto mr-auto" />
        </div>
      </section>
    );
  }
}
